import React from 'react';
import { CreateReport } from '../../../components';
import { useAnomalies } from '../../../hooks/theme.hook';
import { paths } from '../../../routes';
import * as Yup from 'yup';

export const AsctForms: React.FC = () => {
  const { selectedAnomalyType, anomalyTypes, anomalies, handleOnSelectAnomalyType } = useAnomalies(
    '' + paths.asct.themeShortCode
  );

  return (
    <CreateReport
      initialValues={{
        fieldReportsDto: {},
      }}
      themeShortCode={paths.asct.themeShortCode || ''}
      otherFields={{
        'fieldReportsDto.suge': {
          type: 'switch',

          label: 'Présence de la SUGE / Agent de sûreté',
          grid: 6,
          initialValue: true,
        },
        'fieldReportsDto.nbrReceipts': {
          type: 'number',
          label: 'Nombre d’encaissements',
          grid: 6,
        },
        anomalyTypeShortCode: {
          type: 'select',
          label: "Type d'anomalie",
          grid: 6,
          options: anomalyTypes,
        },
        anomalyShortCode: {
          type: 'select',
          label: 'Anomalie',
          grid: 6,
          options: anomalies,
          disabled: !selectedAnomalyType,
        },
        'fieldReportsDto.nbrPV': {
          type: 'number',
          label: 'Nombre de PV',
          grid: 6,
        },
        'fieldReportsDto.comment': {
          type: 'text',
          name: 'comment',
          label: 'Rapport de lancement / Exposer les faits',
          multiline: true,
          rows: 4,
          rowsMax: 15,
        },
      }}
      validationSchema={Yup.object({
        anomalyTypeShortCode: Yup.string().required('Ce champ est requis'),
        anomalyShortCode: Yup.string().required(
          "Ce champ est requis. Merci de choisir un type d'anomalie"
        ),
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
      })}
      onChange={handleOnSelectAnomalyType}
    />
  );
};

export default AsctForms;
